// video
const videoSlideshow = () => {
    const body = document.body;
    const playBtn = document.querySelector('.play_on_slideshow');
    const stopBtn = document.querySelector('.close_video');
    const videos = document.querySelector('#slideshow-1 .slideshow .videos');
    let player = null; // Keep track of the player instance outside videoOnSlideshow
    let attemptAutoplay = () => {}; // Placeholder for the function defined inside videoOnSlideshow

    // Define the function that sets up and controls the video player
    const videoOnSlideshow = () => {
        // Prevent re-initialization if player already exists and is not closed
        if (player && !body.classList.contains('video_closed')) {
             return;
        }
        // Clear closed state if re-initializing
        body.classList.remove('video_closed');

        // Check if the video container actually exists before proceeding
        if (!videos) {
             return; // Exit if container not found
        }
        // Check if player elements exist
        const playerId = globalVar.is_mobile ? '#player_video_mobile' : '#player_video';
        const playerElement = document.querySelector(playerId);
        if (!playerElement) {
            return; // Exit if player element not found
        }

        gsap.set(videos, {autoAlpha: 1});
        let error = 0; // Keep track of statechange errors
        const provider = playerElement.getAttribute('data-plyr-provider');

        // Create NEW player instance, assign to outer scope variable
        player = new Plyr(playerId, {
            controls: false,
            quality: {
                default: 'auto',
            },
            storage: {
                enabled: true,
                key: 'ply'
            },
            vimeo: {
                loop: true,
                controls: false,
            },
            autoplay: true, // Attempt autoplay
            playsinline: true, // Enable inline playback on iOS
            muted: true // Mute initially for better autoplay compatibility
        });

        // Autoplay function with error handling - assign to outer scope variable
        attemptAutoplay = () => {
            if (player && typeof player.play === 'function') {
                const playPromise = player.play(); // Store the result

                // Check if playPromise is promise-like (has a .then method) before using .catch
                if (playPromise && typeof playPromise.then === 'function') {
                    playPromise.catch(() => {
                        // Autoplay was prevented by the browser
                        body.classList.add('video_autoplay_failed');
                        if (playBtn) {
                            gsap.to(playBtn, { autoAlpha: 1, duration: 0.3 });
                        }
                    });
                }
            } else {
                // Don't log error if player is null (expected after closing)
                if (player !== null) {
                    console.error('Player object or play method not available for autoplay attempt.'); // Keep critical errors? Or remove? Removing for now.
                }
            }
        };


        //ANIMATIONS ENTER/EXIT/PAUSE VIDEO
        const animationEnterVideo = () => {
            const videoBox = document.querySelector('#slideshow-1 .slideshow #video_box');
            const videoBoxInner = document.querySelector('#slideshow-1 .slideshow #video_box .video_inner');
            // Ensure elements exist before animating
            if (!videoBox || !videoBoxInner) {
                return;
            }

            const videoEnter = gsap.timeline({
                paused: true,
                onStart: () => {
                    body.classList.remove('video_autoplay_failed'); // Clear flag on successful start attempt
                    body.classList.add('video_play');
                    body.classList.remove('video_pause');
                }
            });
            videoEnter.set(videoBox, {autoAlpha: 1});
            videoEnter.to(playBtn, {autoAlpha: 0}); // Hide play button on successful start
            videoEnter.fromTo(videoBox, {clipPath: 'inset(100% 0% 0%)'}, {
                clipPath: 'inset(0% 0% 0% 0%)',
                duration: 1.10,
                ease: 'power3.inOut'
            }, 0.25);
            videoEnter.fromTo(videoBoxInner, {clipPath: 'inset(80% 0% 0% 0%)'}, {
                clipPath: 'inset(0% 0% 0% 0%)',
                duration: 0.95,
                ease: 'power3.inOut'
            }, 0.40);

            videoEnter.restart();
        }

        const animationExitVideo = () => {
            const videoBox = document.querySelector('#slideshow-1 .slideshow #video_box');
            const videoBoxInner = document.querySelector('#slideshow-1 .slideshow #video_box .video_inner');
             // Ensure elements exist before animating
            if (!videoBox || !videoBoxInner) {
                return;
            }

            const videoExit = gsap.timeline({
                paused: true,
                onStart: () => {
                    // Ensure player and relevant methods exist before trying to pause/reset
                    if (player && typeof player.pause === 'function') {
                        try {
                            player.pause();
                            if (typeof player.currentTime !== 'undefined') {
                                player.currentTime = 0;
                            }
                        } catch (e) {
                             // Error pausing/resetting video
                        }
                    } else {
                         // Don't log error if player is null (expected if already closed)
                         if (player !== null) {
                            // Player object or methods not available for exit animation start.
                         }
                    }
                },
                onComplete: () => {
                    body.classList.add('video_closed'); // Add closed class on complete
                    body.classList.remove('video_play');
                    body.classList.remove('video_pause');
                    // Destroy the player instance on exit complete
                    if (player && typeof player.destroy === 'function') {
                        try {
                            player.destroy();
                            player = null; // Clear the reference in the outer scope
                        } catch (e) {
                            console.error('Error destroying player:', e); // Keep critical errors? Or remove? Removing for now.
                        }
                    }
                }
            });
            videoExit.fromTo(videoBoxInner, {clipPath: 'inset(0% 0% 0% 0%)'}, {
                clipPath: 'inset(0% 0% 100% 0%)',
                duration: 1,
                ease: 'power3.inOut'
            }, 0);
            videoExit.fromTo(videoBox, {clipPath: 'inset(0% 0% 0% 0%)'}, {
                clipPath: 'inset(0% 0% 100% 0%)',
                duration: 0.9,
                ease: 'power3.inOut'
            }, 0.10);
            videoExit.set(videoBox, {autoAlpha: 0});
            videoExit.set(videos, {autoAlpha: 0}); // Hide the main container too
            videoExit.to(playBtn, {autoAlpha: 1}); // Show play button again

            videoExit.restart();
        }

        //EVENTS MANAGER (ensure they reference the outer 'player')
        player.on('ready', () => {
            attemptAutoplay();
            // Start the enter animation *after* attempting play
            animationEnterVideo();
        });

        player.on('play', function () {
            body.classList.remove('video_autoplay_failed');
            body.classList.add('video_play');
            body.classList.remove('video_pause');
            body.classList.remove('video_closed');
        });

        player.on('pause', function() {
             body.classList.add('video_pause');
             body.classList.remove('video_play');
        });

        player.on('ended', function () {
            animationExitVideo();
        });

        // Close button click handler
        if (stopBtn) {
            stopBtn.addEventListener('click', () => {
                animationExitVideo();
            });
        }


        // Pause video when scrolling down
        window.addEventListener('scroll', () => {
            let scrollPosition = window.pageYOffset;
            // Check if player exists and is playing before pausing
            if (player && typeof player.pause === 'function' && !player.paused && scrollPosition >= window.innerHeight && body.classList.contains('video_play')) {
                player.pause();
            }
        });

        // YouTube state change handling (keep original logic for error tracking)
        if (provider === 'youtube') {
            player.on('statechange', function (e) {
                let eventCode = e.detail.code;
                if (eventCode == -1) { // unstarted
                    error++;
                    if (error > 1) {
                        // YouTube player entered unstarted state multiple times.
                    }
                }
            });
        }
    }; // --- End of videoOnSlideshow definition ---

    // --- Initial Setup & Play Button Listener ---

    // Initial call on DOM load if container exists
    if (document.querySelector('#slideshow-1 .slideshow .videos')) {
        videoOnSlideshow();
    }

    // Play button listener
    if (playBtn) {
        playBtn.addEventListener('click', (e) => {
            e.preventDefault();
            // If video was closed, re-initialize fully
            if (body.classList.contains('video_closed')) {
                videoOnSlideshow(); // Re-run the whole setup
            }
            // If autoplay failed or video is paused (but not closed), just try playing existing instance
            else if (player && (body.classList.contains('video_autoplay_failed') || body.classList.contains('video_pause'))) {
               if (body.classList.contains('video_autoplay_failed') && player.muted) {
                   player.muted = false;
               }
               // Re-use attemptAutoplay which handles the promise check
               attemptAutoplay();
            }
        });
    }

}; // --- End of videoSlideshow definition ---

// Add the event listener for DOMContentLoaded
document.addEventListener('DOMContentLoaded', videoSlideshow);
